import React, { useEffect, useRef } from "react";
import { IconButton } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { calibrationService } from "../../../services/CalibrationService";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((_) => ({
    iframeStyle: {
        width: "90%",
        height: "475px",
        border: "0",
        paddingLeft: "10%",
    },
    customIconButton: {
        "&:hover": {
            borderRadius: "15px",
        },
    },
    refreshButton: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "10px 0",
    },
}));

export default function CADToolSheetLoader(props) {
    const {
        setSheetDataLoading,
        sheetId,
        token,
        onPayloadReceived,
        setErrorWithTimeout,
        sheetEmbedUrl,
        setSheetEmbedUrl,
    } = props;
    const classes = useStyles();

    // To avoid infinite re-renders when we want to refresh the iframe, we need to use a ref
    const iframeRef = useRef(null);

    const getGoogleSheet = async () => {
        try {
            setSheetDataLoading(true);
            const result = await calibrationService.getGoogleSheet(sheetId, token);

            // Send our formatted sheet data back up to the parent component
            onPayloadReceived(result);

            // Refresh the iframe to reflect the new data
            if (iframeRef.current) {
                const currentSrc = iframeRef.current.src;
                iframeRef.current.src = ""; // Clear out the iframe's src
                iframeRef.current.src = currentSrc; // Set it back to its original src
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.error || error?.response?.data?.message || error?.message || error;
            console.error(`Error while fetching Google Sheet: ${errorMessage}`);
            setErrorWithTimeout(errorMessage, 10000);

            // Since there was an error, clear out the iframe
            if (iframeRef.current) {
                iframeRef.current.src = "";
            }
        } finally {
            setSheetDataLoading(false);
        }
    };

    useEffect(() => {
        getGoogleSheet();
    }, [sheetId, token, sheetEmbedUrl]);

    return (
        <div>
            <div className={classes.refreshButton}>
                <IconButton onClick={getGoogleSheet} className={classes.customIconButton}>
                    <RefreshIcon />
                    <span>Refetch Sheet Data</span>
                </IconButton>
            </div>
            <iframe ref={iframeRef} className={classes.iframeStyle} src={sheetEmbedUrl} title="Google Sheet" />
            <p style={{ textAlign: "center" }}>
                <i>
                    Note: The document above may not reflect the most recent changes. Refetch the data to ensure you are
                    up to date.
                </i>
            </p>
        </div>
    );
}
